(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sf-logo-marquee"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sf-logo-marquee')) {
  class SfLogoMarquee extends HTMLElement {
    connectedCallback() {
      this.userPaused = false;
      this.onClick = (event) => {
        if (event.target.closest('.sf-logos__toggle')) {
          this.userPaused = !this.userPaused;
          this.render(this.userPaused);
        }
      };
      this.onSelect = (event) => {
        if (this.contains(event.target)) this.render(true);
      };
      this.onDeselect = (event) => {
        if (this.contains(event.target)) this.render(this.userPaused);
      };
      this.addEventListener('click', this.onClick);
      document.addEventListener('shopify:block:select', this.onSelect);
      document.addEventListener('shopify:block:deselect', this.onDeselect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('shopify:block:select', this.onSelect);
      document.removeEventListener('shopify:block:deselect', this.onDeselect);
    }

    render(paused) {
      this.classList.toggle('sf-logos--paused', paused);
      const toggle = this.querySelector('.sf-logos__toggle');
      if (toggle) toggle.setAttribute('aria-pressed', String(paused));
    }
  }
  customElements.define('sf-logo-marquee', SfLogoMarquee);
}

  } catch(e) { console.error(e); }
})();
})();
